import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../../_metronic/_partials/controls";
import { BlockOrg } from "../../../../../../RoleChecker";
import { currencyFormatter } from "../../../pickup/pickup-detail/pickup-detail-table/column-formatters";

export default function MutationBank({
  openMutationBankModal,
  mutationBankData,
  status,
}) {
  // Table columns
  const columns = [
    {
      dataField: "trx_date",
      text: "Tanggal",
    },
    {
      dataField: "message",
      text: "Pesan Bank",
    },
    {
      dataField: "amount",
      text: "Nominal",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
  ];

  return (
    <>
      <Card>
        <CardHeader title="Mutasi Bank">
          <CardHeaderToolbar>
            {BlockOrg() && (
              <>
                {status !== "SETTLE" && (
                  <>
                    <button
                      className="btn btn-primary"
                      onClick={openMutationBankModal}
                    >
                      Cari Transaksi Bank
                    </button>
                  </>
                )}
              </>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            remote
            keyField="uuid"
            data={mutationBankData === null ? [] : mutationBankData}
            columns={columns}
          />
        </CardBody>
      </Card>
    </>
  );
}
